import type { StopLossOrder } from '@/store/orders/stopLoss/state.ts';

export const isStopLossOrder = (order: unknown): order is StopLossOrder => {
  return order !== null && typeof order === 'object' && (order as StopLossOrder).type === 'StopLossOrder';
};
